import { IPrimaryTillageAllResponse } from "../models/IPrimaryTillage.model";
import { AgTechQueryParam, OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import {
  ILocationTrials,
  ILocationTrialsAllResponse,
  ITrialLocation,
  ITrialLocationAllResponse,
  ITrialMasterLocationAllResponse,
} from "../models/ITrialLocation.model";
import NetworkService from "../network/networkService";
import { Observable } from "rxjs";
import { IApplicationStageAllResponse } from "../models/IApplicationStage.model";
import { ICropStageAllResponse } from "../models/ICropStage.model";
import { URLConfig } from "../network/urlStore";
import { IFieldMapRepInfoAllResponse } from "../models/IFieldMapRepInfo.model";
import {
  ISoilTextureAllResponse,
  IYieldEnvironmentAllResponse,
  IYieldEnvironment,
  ISoilTexture,
  ITrialAllResponse,
} from "../models";

export const getTrialLocation = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<ITrialLocationAllResponse> => {
  let url = URLConfig.getTrialLocationURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ITrialLocationAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching trialLocation data", error);
      }
    );
  });
};
export const getTrialLocationNextPage = (
  nextPageURI: string
): Observable<ITrialLocationAllResponse> => {
  const url = URLConfig.getTrialLocationNextPageURL(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (locationResponse) => {
        if (locationResponse) {
          const locationsResponse =
            locationResponse as unknown as ITrialLocationAllResponse;

          subscriber.next(locationsResponse);
        }

        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Locations master data", error);
      }
    );
  });
};

export const getAllTrialLocations = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<ITrialLocation[]> => {
  let allTrialLocations: ITrialLocation[] = [];
  return new Observable((subscriber) => {
    const errorHandler = (error: any) => {
      subscriber.error(error);
    };

    const responseHandler = (response: ITrialLocationAllResponse) => {
      const trialLocationResponse = response;
      allTrialLocations = [
        ...allTrialLocations,
        ...(trialLocationResponse.trialLocations || []),
      ];

      if (trialLocationResponse.nextPageUri) {
        getTrialLocationNextPage(trialLocationResponse.nextPageUri).subscribe({
          next: responseHandler,
          error: errorHandler,
          complete: () => {
            console.info("Completed fetching all trial locations");
          },
        });
      } else {
        subscriber.next(allTrialLocations);
        subscriber.complete();
      }
    };

    getTrialLocation(queryParams).subscribe({
      next: responseHandler,
      error: errorHandler,
      complete: () => {
        console.info("Completed fetching all trial locations");
      },
    });
  });
};

export const getTrialLocationById = (
  id: string,
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<ITrialLocation> => {
  let url = URLConfig.getTrialLocationByIdURL(id);
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ITrialLocation;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching trialLocation data", error);
      }
    );
  });
};

export const getDemoTrialLocationById = (
  id: string,
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<ITrialLocation> => {
  let url = URLConfig.getDemoTrialLocationByIdURL(id);
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ITrialLocation;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching trialLocation data", error);
      }
    );
  });
};

export const updateTrialLocationUsingPatch = (
  requestPayload: any,
  trialLocationId: string
): Observable<any> => {
  const url = URLConfig.updateTrialLocationUsingPatchURL(trialLocationId);

  return new Observable((subscriber) => {
    NetworkService.patch(url, requestPayload).then(
      (res) => {
        const response = res as unknown as ITrialLocation;
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating trialfield", error);
      }
    );
  });
};

export const getPrimaryTillage = (): Observable<IPrimaryTillageAllResponse> => {
  const url = URLConfig.getPrimaryTillageURL();
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IPrimaryTillageAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching trialLocation data", error);
      }
    );
  });
};
export const getApplicationStageList = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<IApplicationStageAllResponse> => {
  let url = URLConfig.getApplicationStageListURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IApplicationStageAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching trialLocation data", error);
      }
    );
  });
};

export const getSoilTexture = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<{ name: string; label: string }[]> => {
  let url = URLConfig.getSoilTextureEnumURL();

  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (soilTextureResponse: unknown) => {
        if (soilTextureResponse) {
          const res = soilTextureResponse as unknown as ISoilTextureAllResponse;

          const formattedData: ISoilTexture[] = res?.values?.map((item) => ({
            name: item,
            label: item,
          }));

          subscriber.next(formattedData);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.error("Error while fetching Soil Texture data", error);
      }
    );
  });
};

export const getYieldEnvironment = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<IYieldEnvironment[]> => {
  let url = URLConfig.getYieldEnvironmentEnumURL();

  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (yieldEnvResponse: unknown) => {
        if (yieldEnvResponse) {
          const res =
            yieldEnvResponse as unknown as IYieldEnvironmentAllResponse;

          const formattedData: IYieldEnvironment[] = res?.values?.map(
            (item) => ({
              name: item,
              label: item,
            })
          );

          subscriber.next(formattedData);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.error("Error while fetching Yield Environment data", error);
      }
    );
  });
};

export const getCropStage = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<ICropStageAllResponse> => {
  let url = URLConfig.getCropStageURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ICropStageAllResponse;

          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching trialLocation data", error);
      }
    );
  });
};
export const createTrialLocation = (requestPayload: any): Observable<any> => {
  const url = URLConfig.getTrialLocationURL();

  return new Observable((subscriber) => {
    NetworkService.post(url, requestPayload).then(
      (trialResponse) => {
        if (trialResponse) {
          const trialsResponse =
            trialResponse as unknown as ITrialLocationAllResponse;
          subscriber.next(trialsResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while creating a Trial", error);
      }
    );
  });
};
export const deleteTrialLocation = (
  trialLocationId: string
): Observable<any> => {
  const url = URLConfig.updateTrialLocationUsingPatchURL(trialLocationId);
  return new Observable((subscriber) => {
    NetworkService.delete(url).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating seasonfield", error);
      }
    );
  });
};

export const getContentLengthForTrialLocation = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getTrialLocationURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};

export const getFieldMapRepInfoNextPage = (
  nextPageURI: string
): Observable<IFieldMapRepInfoAllResponse> => {
  const url = URLConfig.getFieldMapRepInfoNextPageURL(nextPageURI);
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        const response = res as IFieldMapRepInfoAllResponse;
        subscriber.next(response);
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Field Map Rep info", error);
      }
    );
  });
};

export const getFieldMapRepInfo = (
  id: string,
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<IFieldMapRepInfoAllResponse> => {
  let url = URLConfig.getFieldMapRepInfoURL(id);

  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IFieldMapRepInfoAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching Field Map Rep info", error);
      }
    );
  });
};

export const getTrialMasterLocation = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<ITrialMasterLocationAllResponse> => {
  let url = URLConfig.getTrialMasterLocationURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ITrialMasterLocationAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching trialLocation data", error);
      }
    );
  });
};

export const getTrialByLocationId = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<ILocationTrialsAllResponse> => {
  let url = URLConfig.getTrialsByLocationIdURL();
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ILocationTrialsAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching user data", error);
      }
    );
  });
};

export const getTrialByLocationIdNextPage = (
  nextPageUri: string
): Observable<ILocationTrialsAllResponse> => {
  const url = URLConfig.getTrialsByLocationIdNextPageURL(nextPageUri);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ILocationTrialsAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching user data", error);
      }
    );
  });
};


export const getAllTrialsByLocationId = (
  queryParams?: Array<{
    key: AgTechQueryParam;
    value: string[];
  }>
): Observable<ILocationTrials[]> => {
  let allTrials: ILocationTrials[] = [];

  return new Observable((subscriber) => {
    const handleError = (error: any) => {
      subscriber.error(error);
      console.error("Error while fetching TrialByLocationId data", error);
    };

    const handleResponse = (response: ILocationTrialsAllResponse) => {
      allTrials = [...allTrials, ...(response.trials || [])];

      if (response.nextPageUri) {
        getTrialByLocationIdNextPage(response.nextPageUri).subscribe({
          next: handleResponse,
          error: handleError,
        });
      } else {
        subscriber.next(allTrials);
        subscriber.complete();
      }
    };

    getTrialByLocationId(queryParams).subscribe({
      next: handleResponse,
      error: handleError,
    });
  });
};


export const getTrialByLocationNextPage = (
  nextPageURI: string
): Observable<ITrialAllResponse> => {
  const url = URLConfig.getTrialsByLocationIdNextPageURL(nextPageURI);
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ITrialAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching trialLocation data", error);
      }
    );
  });
};
